var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseEarly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 20.58,
    cy: 20.43,
    r: 5.57,
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.58,
    cy: 20.43,
    r: 4.26,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20.9 20.09 20.9 17.48 19.59 17.48 19.59 21.41 20.9 21.41 23.53 21.41 23.53 20.09 20.9 20.09",
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7,20.47A5.53,5.53,0,0,1,14.93,17,8.46,8.46,0,0,1,13.46,6a9.82,9.82,0,0,0,2.21,19.39,6.91,6.91,0,0,0,.91,0A5.56,5.56,0,0,1,13.7,20.47Z",
    style: {
      fill: "#eac282"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEarly);
export default __webpack_public_path__ + "static/media/close-early.6443b57b.svg";
export { ForwardRef as ReactComponent };